var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-algolia-search__wrapper c-site-search"},[_c('site-search-filter'),_vm._v(" "),_c('site-search-results')],1)}
var staticRenderFns = []

export { render, staticRenderFns }